import PropTypes from 'prop-types';

import { handleContactUs } from '../../../helpers/handleContactUs';

import { LIBRARY_VIEW_TYPES } from 'constants/library';

import { Button } from 'design-system';
import {
    AddCircleLineIcon,
    TerminalBoxLineIcon,
    LightbulbFlashLineIcon,
} from 'design-system/Icons';
import CircularIcon from '../../../design-system/CircularIcon/CircularIcon';

export function EmptyIndexPage({
    libraryType,
    onCreatePressed,
    hasCreateAccess = true,
    areFiltersApplied = false,
}) {
    const icon =
        {
            [libraryType === LIBRARY_VIEW_TYPES.personal]: TerminalBoxLineIcon,
            [libraryType === LIBRARY_VIEW_TYPES.shared]: LightbulbFlashLineIcon,
        }[libraryType] || LightbulbFlashLineIcon;

    return (
        <section
            id="empty-index"
            className="flex flex-col py-[80px] items-center gap-4 self-stretch"
        >
            <CircularIcon icon={icon} />

            <div className="flex flex-col items-center gap-2">
                <p className="font-heading-bold text-heading-bold-m text-center">
                    {areFiltersApplied ? (
                        'Nothing found based on your filters.'
                    ) : (
                        <>
                            {libraryType === LIBRARY_VIEW_TYPES.personal &&
                                `You don’t have any Prompts yet.`}
                            {libraryType === LIBRARY_VIEW_TYPES.shared &&
                                'Contact us for team sharing features'}
                        </>
                    )}
                </p>

                <p className="font-body text-body-regular-m max-w-[440px] text-center text-neutral-400">
                    {areFiltersApplied ? (
                        'Try applying a different filter.'
                    ) : (
                        <>
                            {libraryType === LIBRARY_VIEW_TYPES.personal &&
                                hasCreateAccess &&
                                `Try creating one by clicking “New Prompt”.`}
                            {libraryType === LIBRARY_VIEW_TYPES.shared && (
                                <>
                                    You need to have a <strong>Pro Plan</strong> to enable teams and
                                    sharing. Contact us if you are interested in these features.
                                </>
                            )}
                        </>
                    )}
                </p>
            </div>
            {!areFiltersApplied && (
                <>
                    {libraryType === LIBRARY_VIEW_TYPES.personal && hasCreateAccess && (
                        <Button
                            onClick={onCreatePressed}
                            leadingIcon={AddCircleLineIcon}
                            text={`New Prompt`}
                            type="primary"
                            size="sm"
                        />
                    )}
                    {libraryType === LIBRARY_VIEW_TYPES.shared && (
                        <Button
                            onClick={handleContactUs}
                            text={`Contact Us`}
                            type="primary"
                            size="xs"
                        />
                    )}
                </>
            )}
        </section>
    );
}

EmptyIndexPage.propTypes = {
    libraryType: PropTypes.oneOf([LIBRARY_VIEW_TYPES.personal, LIBRARY_VIEW_TYPES.shared])
        .isRequired,
    onCreatePressed: PropTypes.func,
    isOrganizationMember: PropTypes.bool,
};
